import React, { useContext } from 'react';

import { useTranslation } from '@common/hooks/translation';
import { PopupContext } from '@app/dev/contexts/popup';
import { POPUPS } from '@common/constants/popups';

import './style.scss';

const CashoutTypes = () => {
  const t = useTranslation();
  const [{ openPopup, closePopup }] = useContext(PopupContext);

  return (
    <div className="popup-content popup-small transfer-online-wrapper">
      <h3 className="popup-title">{t('Choose Your Cash Out Method')}</h3>
      <i className="global-icon icon-regular-close" onClick={closePopup} />
      <div className="popup-main-content">
        <i className="global-icon icon-cashout transfer-icon" />
        <p className="text-center">{t('You can either print a Cash Out ticket or transfer the amount to your online account.')}</p>
      </div>
      <div className="popup-actions">
        <button
          type="button"
          className="popup-cancel-button"
          onClick={() => openPopup(POPUPS.CASHOUT_BY_TICKET)}
        >
          {t('print ticket')}
        </button>
        <button
          type="button"
          className="popup-confirm-button"
          onClick={() => openPopup(POPUPS.SEARCH_CLIENT_ID)}
        >
          {t('transfer online')}
        </button>
      </div>
    </div>
  );
};

export default CashoutTypes;
